import React from "react";
import { Container } from "../../style";
import {
  ButtonContainer,
  EditButton,
  HomepageContainer,
  PageTitle,
  PageTitleContainer,
  PublishButton,
} from "./style";
import { AiOutlineEdit as EditIcon } from "react-icons/ai";
import { FormattedMessage } from "react-intl";

import ForwardIcon from "../../../../icons/Forward";
import BannerCaroussel from "./carousel";
import CourseList from "./courses";

export default function PreviewHomePage({
  title,
  editRedirect,
  isForm = false,
  onSubmit,
  banners,
  courses,
}) {
  return (
    <Container>
      <PageTitleContainer>
        <PageTitle>{title}</PageTitle>
        <ButtonContainer>
          <EditButton onClick={editRedirect}>
            <EditIcon size={16} />
            <FormattedMessage id="edit" />
          </EditButton>
          {isForm && (
            <PublishButton onClick={onSubmit}>
              <ForwardIcon />
              <FormattedMessage id="preview_banner_button_publish" />
            </PublishButton>
          )}
        </ButtonContainer>
      </PageTitleContainer>

      <HomepageContainer>
        <BannerCaroussel banners={banners} />

        <CourseList courses={courses} />
      </HomepageContainer>
    </Container>
  );
}
